<template>
  <div class="no-admin-block">
    <h6>You have no assigned Datapeople Administrators</h6>
    <p>
      Please reach out to your<br>
      <a target="_blank" rel="noopener noreferrer" :href="`mailto:support@datapeople.io?subject=Datapeople%20Administrator%20Assignment%20Inquiry`">Customer Success Manager</a>
      to select one.
    </p>
  </div>
</template>

<style scoped lang="less">
.no-admin-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 213px;
  width: 100%;
  background: @bg-canvas;
  border-radius: 8px;
  text-align: center;
}

h6 {
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  color: @text-darkest;
}

p {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  color: @text-light;
}

a {
  color: @text-brand;
  cursor: pointer;
}
</style>
